import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';
import { listSchemas } from './crud';
import type { SchemaListFilters } from './types';

const schemasQueryOptions = (filters: SchemaListFilters = {}) =>
  queryOptions({
    queryKey: ['schemas', filters],
    queryFn: () => listSchemas(filters),
    placeholderData: keepPreviousData,
  });

export const useSchemasQuery = (
  filters: SchemaListFilters = {},
  options?: { enabled?: boolean },
) => {
  return useQuery({
    ...schemasQueryOptions(filters),
    enabled: options?.enabled ?? true,
  });
};
